import Vue from 'vue';
import simpleOrderTransformer from './../../transformers/simpleDetailOrder';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const simpleOrder = simpleOrderTransformer.fetchCollection(data.data);
  resolve(simpleOrder);
};

const failed = (error, reject) => reject();

export default (options = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('orders/list-all-orders/search', options))
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/search.js